<template>
  <div class="rodemap">
    <WordDialog :key="index" :data="arr[index]" @jump="jump"></WordDialog>
  </div>
</template>

<script>
//script
import Tools from '../../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../../scripts/Global';
import WordDialog from '../../cmp/wordDialog';

export default {
  data() {
    return {
      index: 0,
      arr: [
        {
          headImg: '苏尚卿讲解',
          word:
            '万春亭位于御花园内浮碧亭以南，明嘉靖十五年建，上圆下方的屋顶取仿“天圆地方”的古明堂形制。',
          audio: 'ssq',
          scene: 'scene8',
        },
        {
          headImg: '苏尚卿讲解',
          word:
            '万春亭与园内千秋亭是一对造型、构造均相同的建筑，仅藻井彩画有细微的差别。',
          audio: 'ssq',
          scene: 'scene9',
        },
      ],
    };
  },
  components: {
    WordDialog,
  },
  created() {},
  computed: {},
  methods: {
    jump(event) {
      this.index += 1;
      if (this.arr.length === this.index) {
        this.$router.replace('/rodemap/ssq/06');
        this.index--;
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/万春亭.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
